var PingRequest = (function () {
    function PingRequest() {
        this._timeAtSender = Date.now();
    }
    PingRequest.prototype.getPtlMessage = function () {
        return {
            Message: PingRequest.NAME,
            Version: PingRequest.VERSION,
            time_at_sender: {
                microseconds: (this._timeAtSender * 1000)
            }
        };
    };
    PingRequest.prototype.resetTimeAtSender = function () {
        this._timeAtSender = Date.now();
    };
    Object.defineProperty(PingRequest.prototype, "timeAtSender", {
        get: function () {
            return this._timeAtSender;
        },
        enumerable: false,
        configurable: true
    });
    PingRequest.NAME = 'PingRequest';
    PingRequest.VERSION = 3;
    return PingRequest;
}());
export { PingRequest };
//# sourceMappingURL=PingRequest.js.map